import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  headerLogos: {
    logoFrontLeft: 'https://aldesmarvin.blob.core.windows.net/cmd/lg/logo-sabadell-bgW-h40.png',
    logoFrontRight: null
  },
  theme: 'ald-banco-sabadell',
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
